export default __webpack_public_path__ + "static/media/search.3af5c37b.svg";